import { Drawer } from '@ui/lib/park/ui/drawer';

import { TokenOption } from './TokenOption';
import { CollateralTokenPickerProps } from './type';

export const PickerDrawer = ({
  onSelect,
  children,
  payableTokens,
  title,
}: CollateralTokenPickerProps) => {
  return (
    <Drawer.Root lazyMount unmountOnExit modal={false} direction="bottom">
      <Drawer.Trigger asChild>{children}</Drawer.Trigger>
      <Drawer.Backdrop />
      <Drawer.Positioner>
        <Drawer.Content bg="v2.bg.panel">
          <Drawer.Header
            flexDir="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Drawer.Title>{title}</Drawer.Title>
            <Drawer.CloseTrigger />
          </Drawer.Header>

          <Drawer.Body
            p="20px 16px 48px 16px"
            display="flex"
            flexDir="column"
            gap="16px"
            borderTop="none"
            overflowY="auto"
          >
            <Drawer.Context>
              {(context) =>
                payableTokens.map((token) => (
                  <TokenOption
                    // MON (native) and WMON (ERC20) intentionally share the same underlying wrapped address.
                    // Using address alone as a React key causes collisions and warnings.
                    key={`${token.symbol}-${token.address.toLowerCase()}`}
                    token={token}
                    onClick={() => {
                      onSelect(token);
                      context.setOpen(false);
                    }}
                  />
                ))
              }
            </Drawer.Context>
          </Drawer.Body>
        </Drawer.Content>
      </Drawer.Positioner>
    </Drawer.Root>
  );
};
